export default "__VITE_ASSET__HQJvjFXq__"